import { render, staticRenderFns } from "./NavigationProductFullWidth.vue?vue&type=template&id=451302fb&"
import script from "./NavigationProductFullWidth.vue?vue&type=script&lang=js&"
export * from "./NavigationProductFullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports